import { URL_DELETE_FILE } from 'constants/urls';

const deleteFile = async (fileId) => {
	const url = `${URL_DELETE_FILE}${fileId}`;

	const options = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json;charset=UTF-8' },
		body: JSON.stringify({ fileId }),
	};

	const res = await fetch(url, options);
	const data = await res.json();

	return data;
};

export default deleteFile;
